//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import creditRequestContainer from "emun.invoice/credit-request/credit-request-container";
import creditRequestDetails from "emun.invoice/credit-request/credit-request-details";

//directives
import creditRequestDetailsLines from "emun.invoice/credit-request/credit-request-details-lines";
import creditRequestDetailsActions from "emun.invoice/credit-request/credit-request-details-actions";
import creditRequestDetailsHeader from "emun.invoice/credit-request/credit-request-details-header";
import creditRequestLineActions from "emun.invoice/credit-request/credit-request-line-actions";
import creditRequestLineAttributes from "emun.invoice/credit-request/credit-request-line-attributes";
import creditRequestLineDetails from "emun.invoice/credit-request/credit-request-line-details";
import creditRequestLineImageActions from "emun.invoice/credit-request/credit-request-line-image-actions";
import creditRequestLineImage from "emun.invoice/credit-request/credit-request-line-image";
import creditRequestLinesHeader from "emun.invoice/credit-request/credit-request-lines-header";
import creditRequestList from "emun.invoice/credit-request/credit-request-list";
import creditRequestListGrid from "emun.invoice/credit-request/credit-request-list-grid";
import creditRequestListCards from "emun.invoice/credit-request/credit-request-list-cards";
import creditRequestSummary from "emun.invoice/credit-request/credit-request-summary";
import creditRequestSummaryActions from "emun.invoice/credit-request/credit-request-summary-actions";

//states
import states from "emun.invoice/credit-request/credit-request.states";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  creditRequestContainer,
  creditRequestDetails,
};

export const directives = {
  creditRequestDetailsHeader,
  creditRequestDetailsLines,
  creditRequestDetailsActions,
  creditRequestLineActions,
  creditRequestLineAttributes,
  creditRequestLineDetails,
  creditRequestLineImageActions,
  creditRequestLineImage,
  creditRequestLinesHeader,
  creditRequestList,
  creditRequestListGrid,
  creditRequestListCards,
  creditRequestDetailsHeader,
  creditRequestSummary,
  creditRequestSummaryActions
};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
